import React from "react";
import { StyleSheet } from "react-native";
import { View } from "@components/atoms/Themed";
import NavigationBar from "@components/molecules/NavigationBar";
import { goBack } from "@navigation/navigate";
import TermsOfUse from "@components/templates/TermsOfUse";

export default function TermsOfUseScreen(): JSX.Element {
  return (
    <View style={styles.content}>
      <NavigationBar onClose={goBack} title="利用規約" />
      <TermsOfUse />
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
});
